
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bananamores",
      function () {
        return require("private-next-pages/bananamores/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bananamores"])
      });
    }
  